var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn"},[_c('a-button',{attrs:{"block":""},on:{"click":function($event){$event.stopPropagation();return _vm.moduleEnter($event)}}},[_vm._v(_vm._s(_vm._f("capitalize")(_vm.$t('enter'))))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }